import request from '@/utils/request2'

// 下拉获取数据
export function listAreaApi(data) {
  return request({
    url: 'tms-web/area/list',
    method: 'post',
    data
  })
}
